<template>
  <div class="refresh-head" :style="{ opacity }">
    <div class="refresh-head__orb">
      <svg viewBox="0 0 42 42" class="refresh-head__svg" aria-hidden="true">
        <defs>
          <linearGradient id="refresh-head-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#3c41c9" />
            <stop offset="100%" stop-color="#9296ff" />
          </linearGradient>
        </defs>
        <circle class="refresh-head__track" cx="21" cy="21" r="13" />
        <circle class="refresh-head__inner" cx="21" cy="21" r="9.5" />
        <g class="refresh-head__arc-group" :transform="arcTransform">
          <animateTransform
            v-if="loading"
            attributeName="transform"
            type="rotate"
            from="0 21 21"
            to="360 21 21"
            dur="0.9s"
            repeatCount="indefinite"
          />
          <circle
            class="refresh-head__arc"
            cx="21"
            cy="21"
            r="13"
            transform="rotate(-90 21 21)"
            :stroke-dasharray="`${arcLength} ${circumference}`"
            :stroke-dashoffset="dashOffset"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  distance: {
    type: Number,
    default: 0
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const triggerDistance = 30;
const circumference = 2 * Math.PI * 13;

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

const progress = computed(() => clamp(props.distance / triggerDistance, 0, 1));
const opacity = computed(() => (props.loading ? 1 : 0.35 + progress.value * 0.65));
const arcLength = computed(() => circumference * (0.18 + progress.value * 0.17));
const dashOffset = computed(() => circumference * 0.25);
const arcTransform = computed(() => (
  props.loading
    ? undefined
    : `rotate(${progress.value * 360} 21 21)`
));
</script>

<style scoped lang="scss">
.refresh-head {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 46px;
  overflow: hidden;
  line-height: normal;
  pointer-events: none;
  transition: opacity 0.12s ease;
}

.refresh-head__orb {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 42px;
  height: 42px;
  transform: translate3d(-50%, -50%, 0);
}

.refresh-head__svg {
  display: block;
  width: 100%;
  height: 100%;
  shape-rendering: geometricPrecision;
}

.refresh-head__track,
.refresh-head__arc {
  fill: none;
  stroke-linecap: round;
  stroke-width: 5;
}

.refresh-head__track {
  stroke: #d6e1fe;
}

.refresh-head__inner {
  fill: #ffffff;
}

.refresh-head__arc {
  stroke: url(#refresh-head-gradient);
}
</style>
